module.exports = __webpack_public_path__ + "img/iconEchart.7d842cf8.svg";